import { type IDetailItemDicInfo } from '@interface/IDetail';
import classNames from 'classnames';
import { Trans } from 'react-i18next';

export const Description = ({ iteminfo }: { iteminfo: IDetailItemDicInfo }) => {
    if (!iteminfo.description) return null;
    return (
        <ul
            className={classNames({
                topborder:
                    iteminfo.randomOptions?.length > 0 ||
                    iteminfo.additional?.count > 0 ||
                    iteminfo.options?.length > 0 ||
                    iteminfo.subOptions.fixes?.length > 0 ||
                    iteminfo.subOptions.randoms?.length > 0,
            })}
        >
            <li>
                <div className="value">
                    <Trans components={{ span: <span /> }}>{iteminfo.description.replace(/\\r\\n|\n/gi, '<br/>')}</Trans>
                </div>
            </li>
        </ul>
    );
};
